module.exports = __webpack_public_path__ + "img/placeholder-event.14961dd2.svg";